// @ts-check

/**
 * @returns {boolean}
 */
export function isSignupFlowCompleted() {
    const completedSignupStep = localStorage.getItem('completedSignupStep');
    return completedSignupStep === '1' ? true : false;
  }
